var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconQuestionMark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 11.333a.667.667 0 1 1 0 1.334.667.667 0 0 1 0-1.334zm0-8a2.667 2.667 0 0 1 .667 5.25v.75a.667.667 0 0 1-1.334 0V8c0-.368.299-.667.667-.667a1.333 1.333 0 1 0-1.327-1.461L6.667 6a.667.667 0 0 1-1.334 0A2.667 2.667 0 0 1 8 3.333z",
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconQuestionMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-question-mark.607a23f66b0b33f19db72d3178ea01a2.svg";